// extracted by mini-css-extract-plugin
export default {"field":"Select_field__w33BM","isBig":"Select_isBig__BQHxy"};